// Copy and imagery here are lifted from the live wandaanalytics.com so the
// rebuild says the same things the client already signed off on. Bios are
// verbatim; anything not on the old site is not invented here.

export const EMAIL = 'info@WandaAnalytics.com';
export const CAREERS_EMAIL = 'careers@wandaanalytics.com';
export const LINKEDIN = 'https://www.linkedin.com/company/wanda-analytics';

export const NAV = [
  { to: '/services', label: 'Services' },
  { to: '/products', label: 'Products' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' }
];

export const STATS = [
  { n: '200+', l: 'BVLOS flights completed' },
  { n: '3,000+', l: 'Utility assets inspected' },
  { n: '5', l: 'States with flight operations' }
];

// The three detection clips are the model output as the live site publishes it:
// looping video with the boxes burned in by Wanda's own detectors, so nothing is
// drawn over the top of them here. Posters are real frames from each clip.
export const DETECTIONS = [
  {
    video: '/assets/detect-solar.mp4',
    poster: '/assets/detect-solar-poster.jpg',
    alt: 'Solar array scan with panel cracks boxed by the detector as the frame advances',
    title: 'Solar panel crack detection',
    meta: 'Live detection',
    frame: 'Solar array — inspection scan'
  },
  {
    video: '/assets/detect-turbine.mp4',
    poster: '/assets/detect-turbine-poster.jpg',
    alt: 'Wind turbine blade close pass with a crack boxed by the detector',
    title: 'Wind turbine crack detection',
    meta: 'Live detection',
    frame: 'Turbine blade — close pass'
  },
  {
    video: '/assets/detect-intruder.mp4',
    poster: '/assets/detect-intruder-poster.jpg',
    alt: 'Night thermal perimeter capture with people tracked and boxed by the detector',
    title: 'Intruder and weapon identification',
    meta: 'Live detection',
    frame: 'Perimeter — night capture'
  }
];

export const TEAM = [
  {
    name: 'Bryan Gabric',
    role: 'Chief Executive Officer',
    img: '/assets/team-bryan.jpg',
    bio: 'Bryan Gabric, CEO and founding member of Wanda Analytics, brings more than a decade of experience in railroad technology, asset management, drone operations, and computer vision. During his career at BNSF Railway, Bryan spent approximately seven years supporting a major engineering asset management initiative before moving into the railroad UAV program, where he worked with drone-based yard monitoring and inventory capture. At Wanda, he combines that operational experience with expertise in UAS technology, machine learning, and visual analytics to develop practical solutions for infrastructure inspection and monitoring. Bryan is an FAA certified remote pilot.'
  },
  {
    name: 'Candice Gabric',
    role: 'Chief Operating Officer',
    img: '/assets/team-candice.jpg',
    bio: 'Candice Gabric, COO and founding member of Wanda Analytics, brings more than a decade of experience across railroad operations, technology, and data. Her background includes signal construction and maintenance leadership, engineering asset management, condition-based maintenance analytics, and complex AI data annotation and quality assurance. At Wanda, she applies her operational and business analysis expertise to complex AI and inspection workflows. She holds a bachelor degree in Electrical Engineering from the University of Texas, and is an FAA Part 107 certified remote pilot.'
  },
  {
    name: 'Todd Graetz',
    role: 'Investor / Advisor',
    img: '/assets/team-todd.jpg',
    bio: 'Todd Graetz, investor/advisor and founding member, has a career defined by transformative achievements in aviation and logistics, with milestones that have set new standards in unmanned aircraft and BVLOS operations. At BNSF Railway, Todd launched the first commercial BVLOS operations in the lower 48 states and continuously expanded these capabilities, leading to over 1,200 miles of daily flights across three states by 2018. By 2020, he had secured the first BVLOS approval in the nation for linear asset inspections, and his leadership culminated in establishing a 28-state production network of dock-based drones with more than 165 pilots. His recent contributions include AI-powered, machine-vision systems that automate complex yard inspections. With a bachelor degree from the University of Denver, further studies in AI at MIT, and a Private Pilot Certificate, Todd combines hands-on expertise with advanced strategic insight. His industry influence extends through board roles with the AUVSI and advisory committees for the FAA, where he has shaped policy and innovation in BVLOS operations and drone technology.'
  },
  {
    name: 'Kate Garrett',
    role: 'UAS Operations Specialist',
    img: '/assets/team-kate.jpg',
    bio: 'Kate Garrett is a Part 107 certified UAS pilot with hands-on experience conducting commercial drone inspections across utility and property environments. Her field work includes infrared inspection of utility infrastructure, property inspections, and structured data collection. Kate brings a strong focus on safety, flight efficiency, and consistent data quality to every operation.'
  }
];

export const FLIGHT_CAPABILITIES = [
  {
    t: 'VLOS & BVLOS operations',
    d: 'Commercial flight operations ranging from conventional missions to repeatable beyond visual line of sight operations.'
  },
  {
    t: 'Thermal imaging',
    d: 'Infrared data collection for applications requiring information beyond standard visual imagery.'
  },
  {
    t: 'Dock operations',
    d: 'Support for remotely operated and dock-enabled UAS workflows.'
  },
  {
    t: 'Mission planning',
    d: 'Flight planning built around the asset, inspection objective, operating environment, and required data.'
  }
];

export const ENGAGE = [
  { n: 'Already have imagery?', d: 'We can work with the data you provide.' },
  { n: 'Need imagery collected?', d: 'Our flight operations team can capture it.' },
  { n: 'Need both?', d: 'Wanda can connect image capture and AI into an integrated workflow.' }
];
